import React from "react";
import { useNavigate } from "react-router-dom";
import { PawPrintIcon as PawPrint, TreeStructureIcon as TreeStructure, BellIcon as Bell, CalendarCheckIcon as CalendarCheck } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

/**
 * NativeWelcome — first screen for signed-out users in the native app.
 * Replaces the web marketing landing page: app-like, no footer, no
 * pricing, two actions. (App Review 4.2 — first-launch experience.)
 */
export default function NativeWelcome() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA] font-manrope text-ink flex flex-col px-8 pt-20 pb-12" data-testid="native-welcome">
      <div className="flex-1 flex flex-col items-center justify-center text-center max-w-sm mx-auto w-full">
        <img
          src="/app-icon-1024.png"
          alt="Armstrong K9 Registry"
          className="w-20 h-20 rounded-2xl shadow-sm mb-6"
        />
        <h1 className="font-serif text-3xl leading-tight mb-3">
          Armstrong K9 Registry
        </h1>
        <p className="text-[15px] text-[#6B6B6B] leading-relaxed mb-10">
          Your dogs, pedigrees, litters, and care records — organized in one
          place, with you everywhere.
        </p>
        <div className="grid grid-cols-2 gap-3 w-full text-left mb-10">
          {[
            { icon: PawPrint, label: "Register & manage dogs" },
            { icon: TreeStructure, label: "Interactive pedigrees" },
            { icon: CalendarCheck, label: "Heat & event reminders" },
            { icon: Bell, label: "Inquiry alerts" },
          ].map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-2.5 rounded-xl border border-[#EAEAEA] bg-white px-3.5 py-3">
              <Icon size={18} weight="duotone" className="text-gold flex-shrink-0" />
              <span className="text-[12px] font-semibold leading-tight">{label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-sm mx-auto w-full space-y-3">
        <Button
          onClick={() => navigate("/register")}
          className="w-full h-12 rounded-full bg-ink hover:bg-crimson text-white text-[15px] font-semibold"
          data-testid="native-welcome-register-btn"
        >
          Create an account
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate("/login")}
          className="w-full h-12 rounded-full border-[#D9D9D9] text-[15px] font-semibold"
          data-testid="native-welcome-login-btn"
        >
          Sign in
        </Button>
      </div>
    </div>
  );
}
